var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textblock w100"},[_c('span',{staticClass:"desktop",domProps:{"innerHTML":_vm._s(_vm.parseText())}}),_vm._v(" "),_c('span',{staticClass:"mobile",domProps:{"innerHTML":_vm._s(_vm.parseTextMobile())}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db902b90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/Textblock.vue
// module id = null
// module chunks = 